import gql from 'graphql-tag';

export const getCourseUnitReport = gql`
  query foCourseUnitReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $schoolCode: String!
  ) {
    foCourseUnitReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      courseCode
      courseName
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          id
          name
          shortName
        }
        classNo
        attendanceRate {
          total
          actual
        }
        examinationRate {
          total
          actual
        }
        growthRate
      }
    }
  }
`;

export const getTKCourseUnitReport = gql`
  query foTKCourseUnitReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $schoolCode: String!
  ) {
    foTKCourseUnitReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      courseCode
      courseName
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          id
          name
          shortName
        }
        classNo
        attendanceRate {
          total
          actual
        }
        examinationRate {
          total
          actual
        }
        growthRate
        mastery
        bloom
      }
    }
  }
`;

export const getIndividualUnitReport = gql`
  query foIndividualUnitReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String!
    $subjectId: ID!
    $courseCode: String!
    $schoolCode: String!
    $classroomUsername: String!
  ) {
    foIndividualUnitReport(
      schoolCode: $schoolCode
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        subjectId: $subjectId
        courseCode: $courseCode
        classNo: $classNo
        classroomUsername: $classroomUsername
      }
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      classNo
      studentNo
      classroomUsername
      firstName
      lastName

      courseCode
      courseName
      reports {
        ... on FOIndividualUnitVideoSubsection {
          sectionCode
          sectionName
          subsectionCode
          subsectionName
          contentType
          status
          watchedPercent
          __typename
        }
        ... on FOIndividualUnitQuizSubsection {
          sectionCode
          sectionName
          subsectionCode
          subsectionName
          contentType
          status
          watchedPercent
          quizResult {
            score
            fullScore
            rank
          }
          __typename
        }
      }
    }
  }
`;

export const getTKIndividualUnitReport = gql`
  query foTKIndividualUnitReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String!
    $subjectId: ID!
    $courseCode: String!
    $schoolCode: String!
    $classroomUsername: String!
  ) {
    foTKIndividualUnitReport(
      schoolCode: $schoolCode
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        subjectId: $subjectId
        courseCode: $courseCode
        classNo: $classNo
        classroomUsername: $classroomUsername
      }
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      classNo
      studentNo
      classroomUsername
      firstName
      lastName

      courseCode
      courseName
      reports {
        ... on FOTKIndividualUnitVideoSubsection {
          sectionCode
          sectionName
          sectionGroupCode
          sectionGroupName
          subsectionCode
          subsectionName
          contentType
          status
          watchedPercent
          __typename
        }
        ... on FOTKIndividualUnitQuizSubsection {
          sectionCode
          sectionName
          sectionGroupCode
          sectionGroupName
          subsectionCode
          subsectionName
          contentType
          status
          watchedPercent
          quizResult {
            score
            fullScore
            rank
          }
          quizArchetypes {
            type
            score
            total
          }
          __typename
        }
      }
    }
  }
`;

export const getCourseCodeReport = gql`
  query foCourseReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String!
    $subjectId: ID!
    $courseCode: String!
    $sectionCode: String
    $schoolCode: String!
  ) {
    foCourseReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
      }
      schoolCode: $schoolCode
    ) {
      reports {
        ... on FOCourseReportQuizResult {
          schoolTerm {
            name
            shortName
          }
          schoolGrade {
            name
            shortName
          }
          classNo
          subject {
            name
            shortName
          }
          courseCode
          courseName
          sectionCode
          sectionName
          subsectionCode
          subsectionName
          contentType
          totalAttemptedStudents
          status
          quizResult {
            good
            normal
            needImprovement
          }
          __typename
        }
        ... on FOCourseReportVideoResult {
          schoolTerm {
            name
            shortName
          }
          schoolGrade {
            name
            shortName
          }
          classNo
          subject {
            name
            shortName
          }
          courseCode
          courseName
          sectionCode
          sectionName
          subsectionCode
          subsectionName
          contentType
          totalAttemptedStudents
          status
          __typename
        }
      }
    }
  }
`;

export const getTKCourseCodeReport = gql`
  query foTKCourseReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String!
    $subjectId: ID!
    $courseCode: String!
    $sectionCode: String
    $schoolCode: String!
  ) {
    foTKCourseReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
      }
      schoolCode: $schoolCode
    ) {
      reports {
        schoolTerm {
          name
          shortName
        }
        schoolGrade {
          name
          shortName
        }
        classNo
        subject {
          name
          shortName
        }
        courseCode
        courseName
        sectionCode
        sectionName
        sectionGroupName
        totalStudentCompletedVideo
        totalStudentCompletedQuiz
        totalStudents
        isContainVideoModule
        isContainQuizModule
        quizArchetypes {
          type
          firstScore
          avg
          bestScore
          total
        }
      }
    }
  }
`;

export const getSectionReport = gql`
  query foSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $sectionCode: String
    $schoolCode: String!
    $quizFilter: String!
  ) {
    foSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
        quizFilter: $quizFilter
      }
      schoolCode: $schoolCode
    ) {
      sectionInfos {
        sectionCode
        sectionName
        subsectionInfos {
          subsectionCode
          subsectionName
          contentType
        }
      }
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          name
          shortName
        }
        classNo
        subsections {
          ... on FOSectionReportQuizResult {
            status
            contentType
            watchedPercent
            quizResult {
              fullScore
              score
              rank
            }
            __typename
          }
          ... on FOSectionReportVideoResult {
            status
            contentType
            watchedPercent
            __typename
          }
        }
      }
    }
  }
`;

export const getTKSectionReport = gql`
  query foTKSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $sectionCode: String
    $schoolCode: String!
    $quizFilter: String!
  ) {
    foTKSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
        quizFilter: $quizFilter
      }
      schoolCode: $schoolCode
    ) {
      sectionInfos {
        sectionCode
        sectionName
        sectionGroupInfos {
          sectionGroupCode
          sectionGroupName
          subsectionInfos {
            subsectionCode
            subsectionName
            contentType
          }
        }
      }
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          name
          shortName
        }
        classNo
        subsections {
          ... on FOTKSectionReportQuizResult {
            status
            contentType
            watchedPercent
            quizResult {
              fullScore
              score
              rank
            }
            __typename
          }
          ... on FOTKSectionReportVideoResult {
            status
            contentType
            watchedPercent
            __typename
          }
        }
      }
    }
  }
`;

export const getSectionReportForExport = gql`
  query foExportSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: String!
  ) {
    foExportSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        shortName
        name
      }
      sectionInfos {
        sectionCode
        sectionName
        subsectionInfos {
          subsectionCode
          subsectionName
          contentType
          courseName
          courseCode
          sectionName
          sectionCode
        }
      }
      reports {
        schoolGrade {
          name
          shortName
        }
        classNo
        studentNo
        classroomUsername
        firstName
        lastName
        subsections {
          subsectionCode
          subsectionName
          contentType
          status
          score
          watchedPercent
        }
      }
    }
  }
`;

export const getTKSectionReportForExport = gql`
  query foTKExportSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: String!
  ) {
    foTKExportSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        shortName
        name
      }
      sectionInfos {
        sectionCode
        sectionName
        sectionGroupInfos {
          sectionGroupCode
          sectionGroupName
          subsectionInfos {
            subsectionCode
            subsectionName
            contentType
            courseName
            courseCode
            sectionName
            sectionCode
          }
        }
      }
      reports {
        schoolGrade {
          name
          shortName
        }
        classNo
        studentNo
        classroomUsername
        firstName
        lastName
        subsections {
          subsectionCode
          subsectionName
          contentType
          status
          score
          watchedPercent
        }
      }
    }
  }
`;

export const getSectionReportAllExamForExport = gql`
  query foSectionReportAllExamExport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: String!
    $sectionCode: String
  ) {
    foSectionReportAllExamExport(
      schoolCode: $schoolCode
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
      }
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        shortName
        name
      }
      sectionInfos {
        sectionCode
        sectionName
        subsectionInfos {
          subsectionCode
          subsectionName
          contentType
          courseName
          courseCode
          sectionName
          sectionCode
        }
      }
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          name
          shortName
        }
        classNo
        subsections {
          subsectionCode
          subsectionName
          contentType
          status
          quizResultList {
            ... on FOSectionReportQuizResultDetail {
              __typename
              rank
              score
              fullScore
              round
            }
          }
        }
      }
    }
  }
`;

export const getTKSectionReportAllExamForExport = gql`
  query foTKSectionReportAllExamExport(
    $schoolTermId: ID!
    $schoolGradeId: ID
    $classNo: String
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: String!
    $sectionCode: String
  ) {
    foTKSectionReportAllExamExport(
      schoolCode: $schoolCode
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        sectionCode: $sectionCode
      }
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        shortName
        name
      }
      sectionInfos {
        sectionCode
        sectionName
        sectionGroupInfos {
          sectionGroupCode
          sectionGroupName
          subsectionInfos {
            subsectionCode
            subsectionName
            contentType
            courseName
            courseCode
            sectionName
            sectionCode
          }
        }
      }
      reports {
        studentNo
        classroomUsername
        firstName
        lastName
        schoolGrade {
          name
          shortName
        }
        classNo
        subsections {
          subsectionCode
          subsectionName
          contentType
          status
          quizResultList {
            ... on FOTKSectionReportQuizResultDetail {
              __typename
              rank
              score
              fullScore
              round
            }
          }
        }
      }
    }
  }
`;

export const getCourseGradeReport = gql`
  query foCourseGradeReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $subjectId: ID!
    $schoolCode: String!
  ) {
    foCourseGradeReport(
      search: { schoolTermId: $schoolTermId, schoolGradeId: $schoolGradeId, subjectId: $subjectId }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      classes {
        classNo
        courses {
          code
          attendanceRate
          examinationRate
          examinationAverageResult
          growthRate
        }
      }
      courses {
        courseName
        courseCode
      }
      asOfDate
    }
  }
`;

export const getTKCourseGradeReport = gql`
  query foTKCourseGradeReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $subjectId: ID!
    $schoolCode: String!
  ) {
    foTKCourseGradeReport(
      search: { schoolTermId: $schoolTermId, schoolGradeId: $schoolGradeId, subjectId: $subjectId }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      classes {
        classNo
        totalStudents
        courses {
          code
          attendanceRate {
            min
            max
            average
            median
          }
          examinationRate {
            min
            max
            average
            median
          }
          masteryLV1
          masteryLV2
          masteryLV3
          masteryLV4
          growthRate {
            min
            max
            average
            median
          }
        }
      }
      courses {
        courseName
        courseCode
      }
    }
  }
`;

export const getCourseSectionReport = gql`
  query foCourseSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: ID!
  ) {
    foCourseSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      course {
        courseCode
        courseTitle
      }
      classes {
        classNo
        courseSections {
          courseSectionId
          courseSectionTitle
          attendanceRate
          examinationRate
          examinationAverageResult
        }
      }
      courseSections {
        courseSectionId
        courseSectionTitle
      }
      asOfDate
    }
  }
`;

export const getTKCourseSectionReport = gql`
  query foTKCourseSectionReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $subjectId: ID!
    $schoolCode: String!
    $courseCode: ID!
  ) {
    foTKCourseSectionReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        subjectId: $subjectId
        courseCode: $courseCode
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      course {
        courseCode
        courseTitle
      }
      classes {
        classNo
        courseSections {
          courseSectionId
          courseSectionTitle
          attendanceRate {
            max
            min
            average
            median
          }
          examinationRate {
            max
            min
            average
            median
          }
        }
      }
      courseSections {
        courseSectionId
        courseSectionTitle
      }
    }
  }
`;

export const getLearningResultReport = gql`
  query foLearningResultReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String
    $subjectId: ID!
    $courseCode: String
    $lessonId: String
    $schoolCode: String!
  ) {
    foLearningResultReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        lessonId: $lessonId
      }
      schoolCode: $schoolCode
    ) {
      stats {
        gainScore {
          none
          beginner
          intermediate
          advanced
          expert
        }
        mastery {
          LV1
          LV2
          LV3
          LV4
        }
        bloom {
          C1
          C2
          C3
          C4
        }
        showGrowth
      }
      students {
        grade
        classNo
        studentNo
        classroomUsername
        firstName
        lastName
        growthRate
        mastery
        bloom
        egg
        eggTotal
      }
    }
  }
`;

export const getLearningResultReportExport = gql`
  query foLearningResultReportExport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String
    $subjectId: ID!
    $courseCode: String
    $lessonId: String
    $schoolCode: String!
  ) {
    foLearningResultReportExport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        lessonId: $lessonId
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      schoolGrade {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      courseCode
      courseName
      sheet1 {
        classNo
        courseCode
        courseName
        LV1
        LV2
        LV3
        LV4
        C1
        C2
        C3
        C4
      }
      sheet2 {
        classNo
        courseCode
        courseName
        none
        beginner
        intermediate
        advanced
        expert
      }
      sheet3 {
        classNo
        courseCode
        courseName
        studentNo
        classroomUsername
        firstName
        lastName
        mastery
        bloom
        egg
        eggTotal
      }
      sheet4 {
        classNo
        courseCode
        courseName
        studentNo
        classroomUsername
        firstName
        lastName
        pretest
        posttest
        growthRate
        prerequisite
        pisa
      }
      lessonClassSheet {
        classNo
        courseCode
        lessonId
        lessonName
        lessonOrder
        LV1
        LV2
        LV3
        LV4
        C1
        C2
        C3
        C4
      }
      lessonStudentSheet {
        classNo
        courseCode
        lessonId
        lessonName
        lessonOrder
        studentNo
        classroomUsername
        firstName
        lastName
        mastery
        bloom
      }
    }
  }
`;

export const getQuizFeedReport = gql`
  query foQuizFeedReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $lessonName: String
    $schoolCode: String!
  ) {
    foQuizFeedReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        lessonName: $lessonName
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      courseCode
      courseName
      isSupported
      reports {
        classroomUsername
        studentName
        schoolGrade {
          id
          name
          shortName
        }
        classNo
        courseCode
        courseName
        lessonName
        tryQuiz {
          correct
          total
          accuracy
        }
        adaptiveQuiz {
          correct
          total
          accuracy
        }
        mastery
      }
    }
  }
`;

export const getQuizFeedAttemptReport = gql`
  query foQuizFeedAttemptReport(
    $schoolTermId: ID!
    $schoolGradeId: ID!
    $classNo: String
    $subjectId: ID!
    $courseCode: String!
    $lessonName: String
    $classroomUsername: String!
    $schoolCode: String!
  ) {
    foQuizFeedAttemptReport(
      search: {
        schoolTermId: $schoolTermId
        schoolGradeId: $schoolGradeId
        classNo: $classNo
        subjectId: $subjectId
        courseCode: $courseCode
        lessonName: $lessonName
        classroomUsername: $classroomUsername
      }
      schoolCode: $schoolCode
    ) {
      schoolTerm {
        name
        shortName
      }
      subject {
        name
        shortName
      }
      courseCode
      courseName
      isSupported
      classroomUsername
      firstName
      lastName
      attempts {
        attemptNo
        courseCode
        courseName
        lessonName
        startedAt
        endedAt
        adaptiveQuiz {
          correct
          total
          accuracy
        }
      }
    }
  }
`;
